var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.009 19.022C14.8775 19.022 14.7472 18.996 14.6257 18.9456C14.5042 18.8951 14.3939 18.8212 14.301 18.728L8.31001 12.72C8.21703 12.6272 8.14328 12.5169 8.09295 12.3955C8.04263 12.2741 8.01672 12.144 8.01672 12.0125C8.01672 11.8811 8.04263 11.751 8.09295 11.6296C8.14328 11.5082 8.21703 11.3979 8.31001 11.305L14.319 5.31404C14.5068 5.12653 14.7614 5.0213 15.0267 5.02148C15.2921 5.02167 15.5465 5.12727 15.734 5.31504C15.9215 5.50281 16.0268 5.75738 16.0266 6.02275C16.0264 6.28811 15.9208 6.54253 15.733 6.73004L10.433 12.015L15.718 17.315C15.8575 17.455 15.9525 17.6332 15.9908 17.8271C16.0291 18.0209 16.0092 18.2218 15.9334 18.4043C15.8577 18.5869 15.7295 18.7429 15.5652 18.8526C15.4008 18.9624 15.2076 19.021 15.01 19.021L15.009 19.022Z",
    fill: "#393A3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/chevron-left.efa616891cad600f3335edcf284f14c6.svg";
export { ForwardRef as ReactComponent };